<div class="row">
    <div [ngClass]="isAdd ? 'col-sm-6' : 'col-sm-10'">
        <kendo-grid #tableGrid
                    [data]="gridData"
                    [pageSize]="gridState.take"
                    [skip]="gridState.skip"
                    [sort]="gridState.sort"
                    [filter]="gridState.filter"
                    [pageable]="true"
                    [sortable]="true"
                    [filterable]="true"
                    [resizable]="true"
                    (dataStateChange)="dataStateChange($event)">
            <kendo-grid-column title="Action">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <button type="button" class="btn btn-sml btn-danger m-1" title="Delete" tabindex="-1" (click)="delete(dataItem.employeeGroupMapID)"><i class="fas fa-times"></i></button>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="lastName" title="Last Name"></kendo-grid-column>
            <kendo-grid-column field="firstName" title="First Name"></kendo-grid-column>
        </kendo-grid>
    </div>
    <div class="col-sm-2" *ngIf="!isAdd">
        <button class="btn btn-sml btn-secondary" title="Close" tabindex="-1" (click)="close()" *ngIf="!isAdd"><i class="fas fa-times"></i></button>
        <button class="btn btn-sml btn-primary" title="Add New" tabindex="-1" (click)="addNew()" *ngIf="!isAdd"><i class="fas fa-plus"></i></button>
    </div>

    <div class="col-sm-6" *ngIf="isAdd">
        <div class="row">
            <div class="col">
                <label class="fw-bold">Employee</label>
                <select name="employeeID" [(ngModel)]="employeeID" class="form-select" required>
                    <option *ngFor="let emp of employeeList" value="{{emp.employeeId}}">{{emp.fullName}} ({{emp.winUserName}})</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()">Save</button>
                <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>
